if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      // Initialize cart object properly if it doesn't exist
      if (this.cart && !this.cart.getSectionsToRender) {
        this.cart.getSectionsToRender = function() { return []; };
        this.cart.renderContents = function(response) {
          // Use global refresh instead of trying to render cart drawer
          if (window.refreshCartCounter) {
            window.refreshCartCounter();
          }
        };
        this.cart.setActiveElement = function(element) { /* no-op */ };
      }
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Add comprehensive loading state
      this.setLoadingState(true);
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.dataset.cartType != 'page' && this.cart && this.cart.getSectionsToRender) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (this.cart.setActiveElement) {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log('Product add to cart response (full object):', response);
          console.log('Response properties:', Object.keys(response));
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
                        // Update cart counter before redirecting to cart page
            if (window.refreshCartCounter) {
              window.refreshCartCounter();
            }
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

                                        // Always refresh cart counter from server after adding item
          // Don't trust the add response for total count, get fresh cart data
          console.log('Product added successfully, refreshing cart counter from server...');

          // Show brief success state
          this.showSuccessState();

          if (window.refreshCartCounter) {
            window.refreshCartCounter();
          } else {
            // Fallback if refreshCartCounter not available
            fetch('/cart.js')
              .then(res => res.json())
              .then(cartData => {
                console.log('Current cart data after add:', cartData);
                const currentCount = cartData.item_count || cartData.items_count || cartData.total_quantity || 0;
                if (window.updateCartCount) {
                  window.updateCartCount(currentCount);
                }
              })
              .catch(err => console.error('Error fetching current cart:', err));
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (this.cart && this.cart.renderContents) {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Remove loading state
          this.setLoadingState(false);
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    setLoadingState(isLoading) {
      const button = this.submitButton;
      if (!button) return;

      if (isLoading) {
        // Store original text
        if (!button.dataset.originalText) {
          const span = button.querySelector('span');
          button.dataset.originalText = span ? span.textContent : button.textContent;
        }

        // Update button appearance
        button.style.opacity = '0.7';
        button.style.cursor = 'not-allowed';
        button.disabled = true;

        // Update button text
        const span = button.querySelector('span');
        if (span) {
          span.textContent = 'Adding...';
        } else {
          button.textContent = 'Adding...';
        }

        // Add loading class for CSS animations
        button.classList.add('btn-loading');
      } else {
        // Restore original state
        button.style.opacity = '';
        button.style.cursor = '';
        button.disabled = false;

        // Restore original text
        if (button.dataset.originalText) {
          const span = button.querySelector('span');
          if (span) {
            span.textContent = button.dataset.originalText;
          } else {
            button.textContent = button.dataset.originalText;
          }
        }

        // Remove loading class
        button.classList.remove('btn-loading');
      }
    }

    showSuccessState() {
      const button = this.submitButton;
      if (!button) return;

      // Briefly show success state
      button.classList.add('btn-success');
      const span = button.querySelector('span');
      const originalText = button.dataset.originalText;

      if (span) {
        span.textContent = 'Added!';
      }

      // Remove success state after 1 second
      setTimeout(() => {
        button.classList.remove('btn-success');
        if (span && originalText) {
          span.textContent = originalText;
        }
      }, 1000);
    }
  });
}
